import React from "react";
import {gql} from "@apollo/client";
import {useTranslation} from "react-i18next";
import {useFormState} from "../../hooks/useFormState";

import {ProjectInput, Project, LanguageCode} from "../../schema";
import {getLanguages} from "../../i18n";
import {classes as tourClasses} from "../../scenes/editor/project-edit.tour";

import WithTooltip from "../../ui/tooltip";
import {HelpCircleIcon} from "../../ui/icons";
import Select from "../../ui/select";
import ChallengesTableTable from "./challenges-table/ChallengesTable.table";

import cn from "classnames";
import classes from "./ProjectCustomizeForm.module.css";

type props = {
  className?: string,
  project: Project,
  onSave: (data: ProjectInput) => void,
}

type formState = {
  languageCode: LanguageCode
}

export default function ProjectCustomizeForm({className, project, onSave}: props) {
  const {t} = useTranslation();

  const formState = useFormState<formState>({
    initialValues: {
      languageCode: project.languageCode
    },
    preventDefault: true,
    onChange: onSave
  });

  return (
    <form className={className} method="post" onSubmit={formState.submitHandler} autoComplete="off">
      <div className={cn(classes.formItem, tourClasses.language)}>
        <label className={classes.label}>
          {t("components.ProjectCustomizeForm.language.label")}
          {" "}
          <WithTooltip className={classes.help} as='span'
                      helpText={t("components.ProjectCustomizeForm.language.helpText")}>
            <HelpCircleIcon/>
          </WithTooltip>
        </label>
        <WithTooltip className={classes.help} as='span'
                      helpText={t("components.ProjectCustomizeForm.language.helpText")}>
          <Select name="languageCode" value={formState.values.languageCode ?? undefined}
                  onChange={formState.changeHandler}>
            {getLanguages().map(lang => (
              <option key={lang.lang} value={lang.languageCode}>{lang.verboseName}</option>
            ))}
          </Select>
        </WithTooltip>
      </div>
      </form>
  )
}

ProjectCustomizeForm.fragments = {
  root: gql`fragment ProjectCustomizeForm on Project {
    __typename
    id
    name
    languageCode
    isInitial
    challenges {
      ...ChallengesTableTable
    }
  }

  ${ChallengesTableTable.fragments.root}`
}
